<!--
 * @Description: 公司信息认证
 * @Author: yingbin
 * @Date: 2019-09-02 21:03:52
 * @LastEditTime: 2019-09-16 15:31:13
 * @LastEditors: yingbin
 -->
<template>
  <div class="userInfo" ref="company">
    <div class="title">
      <div class="_p">企业认证</div>
      <div v-show="currentView != 'companyAuth'" class="_status">
        <div v-show="auth == 0" class="nosub">未认证</div>
        <div v-show="auth == 1" class="subing">认证中</div>
        <div v-show="auth == 2" class="pass">已认证</div>
        <div v-show="auth == 3" class="unpass">认证失败</div>
      </div>
    </div>
    <component :is="currentView"></component>
  </div>
</template>
<script>
import uitls from "@/utils/utils";
import companyAuth from "./companyAuth.vue";
import companyInfo from "./companyInfo.vue";
import autoDefault from "./autoDefault.vue";
import company from "@/apis/company_apis";
export default {
  data() {
    return {
      isShow: false,
      currentView: "",
      companyInfo: {},
      auth: -1
    };
  },
  created() {
    this.getCompanyInfo();
  },
  methods: {
    // 切换组件
    switchComponent(name) {
      this.currentView = name
    },
    // 获取公司信息
    getCompanyInfo() {
      company.getCompanyInfo(this).then(res => {
        if (res.success) {
          if (res.data == null) {
            this.currentView = "autoDefault";
            this.auth = 0; // 未认证
            return;
          }
          if (res.data) {
            this.currentView = 'autoDefault'
            if(res.data){
              this.companyInfo = res.data
              // this.companyInfo.cardImg = uitls.checkDomain()+'/openapi-interface/companyImage/'+res.data.cardImg
              // this.companyInfo.cardImg = '/openapi-interface/companyImage'
              this.auth = res.data.auditStatus
            }
          }
        }
      });
    }
  },
  components: {
    autoDefault, //未认证
    companyAuth,
    companyInfo
  }
};
</script>

<style lang="less" scoped>
.userInfo {
  .title {
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;

    &::after {
      content: "";
      position: absolute;
      height: 1px;
      left: 0px;
      right: 0px;
      bottom: 0;
      background: #ebebec;
    }

    ._p {
      font-size: 16px;
      position: relative;
      cursor: pointer;
      color: #333333;

      &::after {
        content: "";
        position: absolute;
        width: 4px;
        left: -20px;
        top: 5px;
        bottom: 5px;
        background: #fabe00;
      }
    }

    ._status {
      padding-left: 15px;

      > div {
        width: 75px;
        height: 32px;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        border-radius: 4px;
      }

      .nosub {
        background: #fffbec;
        color: #fac100;
      }

      .subing {
        background: #f3f3ff;
        color: #4e72e7;
      }

      .pass {
        color: #75bd65;
        background: rgba(117, 189, 101, 0.3);
      }

      .unpass {
        color: #ff6f6f;
        background: rgba(255, 111, 111, 0.3);
      }
    }
  }
}
</style>
